import {
  ListVaultAccountsApi,
  type Configuration,
  VaultsApi,
  type CreateVaultRequest,
} from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import type { HttpClient } from './httpClient';

const baseUrl = '/vaults';

export const vaults = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const vaultsApi = new VaultsApi(config);
  const listVaultAccountsApi = new ListVaultAccountsApi(config);
  return {
    useList: () =>
      httpClient.execute(
        vaultsApi.listVaults.bind(vaultsApi),
        baseUrl,
        '/vaults',
        currentProjectId
      ),
    create: (vault: BackupVault) => {
      // Convert BackupVault to CreateBackupVaultInput
      const createInput: CreateVaultRequest = {
        name: vault.name,
        vaultAccountId: vault.vaultAccountId,
        region: vault.region,
        vaultAttributes: {
          cloudProvider: vault.vaultAttributes.cloudProvider,
          aws: {
            encryptionKey: vault.vaultAttributes.aws?.encryptionKey,
          },
          azure: {
            tenantId: vault.vaultAttributes.azure?.tenantId,
          },
          gcp: {
            encryptionKey: vault.vaultAttributes.gcp?.encryptionKey,
          },
        },
        bucketName: vault.vaultAttributes.aws?.bucketName || undefined,
      };

      return vaultsApi.createVault(currentProjectId, createInput);
    },
    update: (vault: BackupVault) =>
      vaultsApi.updateVault(vault.id, currentProjectId, {
        name: vault.name,
      }),
    useAccounts: () =>
      httpClient.execute(
        listVaultAccountsApi.listVaultAccounts.bind(listVaultAccountsApi),
        baseUrl,
        'vault-accounts'
      ),
  };
};
